import { graphql } from 'react-relay';

export default graphql`
    query popularSearchesSitemapRootQuery($uriRef: String!, $page: Int!) {
        viewer {
            popularSearchesSitemap(uriRef: $uriRef) {
                categoryName
                popularBuyPages(first: 1) {
                    edges {
                        node {
                            path
                        }
                    }
                }
            }
            ...PopularSearchesSitemapLayout_viewer
        }
    }
`;
